import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  DurationUnit_MINUTES_getInstancejlptjvjgjkm8 as DurationUnit_MINUTES_getInstance,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { initMetadataForInterface1egvbzx539z91 as initMetadataForInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_insert__zfngmn($this, item, $completion) {
  var tmp = $this.beo(item, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.let' call
  var it = tmp;
  return $this.geo(it.f40());
}
function item$default(id, maximumAge, pullFrequency, $super) {
  maximumAge = maximumAge === VOID ? Companion_getInstance().pj_1 : maximumAge;
  var tmp;
  if (pullFrequency === VOID) {
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
  } else {
    tmp = pullFrequency;
  }
  pullFrequency = tmp;
  return $super === VOID ? this.xen(id, maximumAge, pullFrequency) : $super.xen.call(this, id, new (Duration())(maximumAge), new (Duration())(pullFrequency));
}
function list$default(query, maximumAge, pullFrequency, $super) {
  maximumAge = maximumAge === VOID ? Companion_getInstance().pj_1 : maximumAge;
  var tmp;
  if (pullFrequency === VOID) {
    // Inline function 'kotlin.time.Companion.seconds' call
    Companion_getInstance();
    tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
  } else {
    tmp = pullFrequency;
  }
  pullFrequency = tmp;
  return $super === VOID ? this.zen(query, maximumAge, pullFrequency) : $super.zen.call(this, query, new (Duration())(maximumAge), new (Duration())(pullFrequency));
}
function get(id) {
  // Inline function 'kotlin.time.Companion.minutes' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(1, DurationUnit_MINUTES_getInstance());
  return this.yen(id, VOID, tmp$ret$0);
}
function query(query) {
  // Inline function 'kotlin.time.Companion.minutes' call
  Companion_getInstance();
  var tmp$ret$0 = toDuration(1, DurationUnit_MINUTES_getInstance());
  return this.aeo(query, VOID, tmp$ret$0);
}
function watch(id) {
  return this.yen(id);
}
function watch_0(query) {
  return this.aeo(query);
}
function insert(item, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_insert__zfngmn.bind(VOID, this, item), $completion);
}
var ModelCacheLikeClass;
function ModelCacheLike() {
  if (ModelCacheLikeClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'ModelCacheLike', VOID, VOID, VOID, [1]);
    ModelCacheLikeClass = $;
  }
  return ModelCacheLikeClass;
}
//region block: exports
export {
  get as getejg6weymx5xn,
  query as query29ckg2onhz2o6,
  watch as watchfa0nguk2p1l7,
  watch_0 as watchixvkipmba2qg,
  ModelCacheLike as ModelCacheLike1q3b58tuu7jn2,
  insert as insert3im47febzvlie,
  item$default as item$default3dyc55m87z853,
  list$default as list$defaultjjoam74xw8wt,
};
//endregion

//# sourceMappingURL=ModelCacheLike.mjs.map
